import { Box, Button, Container, Flex, Heading } from '@chakra-ui/react'
import { ArrowLeft } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface AnalyticsLayoutProps {
  children: React.ReactNode
}

/**
 * Standalone shell for the analytics dashboard, deliberately not the chat
 * layout. Analytics is its own context with no historic-chats rail.
 */
const AnalyticsLayout: React.FC<AnalyticsLayoutProps> = ({ children }) => {
  const navigate = useNavigate()

  return (
    <Flex direction='column' minH='100dvh' bg='gray.50'>
      <Flex
        as='header'
        align='center'
        position='relative'
        px={6}
        py={4}
        bg='white'
        borderBottomWidth='1px'
        borderColor='gray.200'
      >
        <Button
          variant='ghost'
          size='sm'
          onClick={() => navigate('/')}
          aria-label='Back to chat'
        >
          <ArrowLeft size={20} />
          {/* Collapse to just the arrow on narrow screens so the button never
              overlaps the absolutely-centered title. */}
          <Box as='span' ml={2} display={{ base: 'none', sm: 'inline' }}>
            Back to chat
          </Box>
        </Button>
        <Heading
          size='md'
          position='absolute'
          left='50%'
          transform='translateX(-50%)'
        >
          Usage Analytics
        </Heading>
      </Flex>
      <Box flex='1' overflowY='auto'>
        <Container maxW='container.xl' py={8}>
          {children}
        </Container>
      </Box>
    </Flex>
  )
}

export default AnalyticsLayout
